import React from "react";
import "./TopBar.css";

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="container top-bar-content">
        <div className="logo">
          {/* <span className="logo-text">PASSION CARE 4 U</span> */}
        </div>
        <div className="contact-info">
          {/* <a href="tel:+27780020549" className="phone-link">
            +27 780020549
          </a>
          <a href="tel:+260773393067" className="phone-link">
            +260 773393067
          </a>
          <a href="mailto:passioncare4uever@gmail.com" className="email-link">
            passioncare4uever@gmail.com
          </a> */}
          <a href="/contact" className="btn-get-in-touch">
            GET IN TOUCH
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
